import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { ConfigService } from '../components/auth/services/config-service/config-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private utilitiesService: UtilitiesService,
    private configService: ConfigService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Observable<boolean> | boolean {
    if (this._authService.isLoggedIn) {
      // Exige vínculo de usuário resolvido (matrícula). Sessão sem vínculo
      // (ex: email antigo, sessão corrompida) é encerrada e volta ao login.
      if (!this._authService.temVinculoUsuario()) {
        this._authService.limpaLocalStorage();
        this._router.navigate(['/login']);
        return false;
      }

      if (this.configService.isWizardPending() && !state.url.includes("configuracao-inicial")) {
        this._router.navigate(['/configuracao-inicial']);
        return false;
      }
      return true;
    }
    this._router.navigate(['/login']);
    return this._authService.isLoggedIn;
  }

}
